import { IonContent, IonPage } from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";

import SettingStudents from "../../../templates/teacher/SettingStudents";
import styles from "../common.module.scss";
import EmbeddedHeader from "../../../organisms/teacher/Header/EmbeddedHeader";
import {
  Context,
  createCategory,
  CREATE_CATEGORY_SUCCESS,
} from "../../../store/teacher";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import Toast from "../../../molecules/Toast";

const SettingStudentsPage = () => {
  const { dispatch, contextState } = useContext(Context);
  const [calling, peep] = useWaitApiCall(contextState);
  const [toastMessage, setToastMessage] = useState("");

  const createCategoryFunc = (params: {
    name: string;
    class_ids: number[];
    color: string;
  }) => {
    !calling && dispatch(peep(createCategory(params)));
  };

  useEffect(() => {
    contextState.lastAction === CREATE_CATEGORY_SUCCESS &&
      setToastMessage(contextState.success_message);
  }, [contextState]);

  return (
    <IonPage>
      <IonContent className={clsx(styles.wrapper, styles.bgWhileBase)}>
        <Toast
          type="success"
          showToast={!!toastMessage}
          onClose={() => setToastMessage("")}
          message={toastMessage}
        />
        <div className={styles.container}>
          <EmbeddedHeader title="生徒画面設定" />
          <SettingStudents
            assignedClasses={contextState.teacher.classes}
            calling={calling}
            createCategory={createCategoryFunc}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default SettingStudentsPage;
